import { render, staticRenderFns } from "./v-video-module.vue?vue&type=template&id=a2d7144e&scoped=true&"
import script from "./v-video-module.vue?vue&type=script&lang=ts&"
export * from "./v-video-module.vue?vue&type=script&lang=ts&"
import style0 from "./v-video-module.vue?vue&type=style&index=0&id=a2d7144e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d7144e",
  null
  
)

export default component.exports